<template>
  <nav
    class="flex items-center justify-between flex-wrap bg-white shadow relative z-50 py-2 px-6 mb-5"
  >
    <div class="flex items-center flex-shrink-0 text-white mr-6">
      <img src="logo.png" alt="Compo Make" class="h-16" />
    </div>
    <div class="block lg:hidden" @click="active=!active">
      <button
        class="flex items-center px-3 py-2 border rounded text-primary border-primary hover:text-white hover:border-white hover:bg-primary"
      >
        <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </button>
    </div>
    <transition name="fade">
      <div
        class="w-full block flex-grow lg:flex lg:items-center lg:w-auto"
        v-show="active || window >= 1025"
      >
        <div class="text-sm lg:flex-grow">
          <a
            href="#responsive-header"
            class="block mt-4 lg:inline-block lg:mt-0 text-primary hover:text-white mr-4"
          >Docs</a>
          <a
            href="#responsive-header"
            class="block mt-4 lg:inline-block lg:mt-0 text-primary hover:text-white mr-4"
          >Examples</a>
          <a
            href="#responsive-header"
            class="block mt-4 lg:inline-block lg:mt-0 text-primary hover:text-white"
          >Blog</a>
        </div>
        <div>
          <a
            href="#"
            class="inline-block text-sm px-4 py-2 leading-none border rounded text-primary border-primary hover:border-transparent hover:text-white hover:bg-primary mt-4 lg:mt-0"
          >Download</a>
        </div>
      </div>
    </transition>
  </nav>
</template>
<script>
export default {
  name: 'Menu',
  data(){
    return {
      active:false,
      window:0
    }
  },
  mounted(){
     window.addEventListener("resize", ()=>{
      console.log(document.documentElement.clientWidth)
      console.log('resize')
      this.window = document.documentElement.clientWidth;
    });
  }
}
</script>
<style>
.logo {
  height: 32px;
}
</style>
